import React from "react";
import { Box, AppBar as MuiAppbar, Toolbar } from "@mui/material";
import { styled } from "@mui/system";
import logo_placeholder from "../../../assets/logo_placeholder.png";
const StyledAppBar = styled(MuiAppbar)(({ theme }) => ({
  backgroundColor: "#fff",
  position: "static",
  width: "100%",
  [[theme.breakpoints.between("xs", "lg")]]: {},
  [theme.breakpoints.up("lg")]: {},
  boxShadow: " 0px 3px 6px #0000000d",
}));

const Logo = styled("img")(({ theme }) => ({
  height: "100%",
  paddingTop: "8px",
  paddingBottom: "8px",
  width: "auto",
  [[theme.breakpoints.between("md", "lg")]]: {
    maxWidth: "45%",
  },
  [theme.breakpoints.up("lg")]: {
    maxWidth: "40%",
  },
}));

const Wrapper = styled(Box)(({ theme }) => ({
  width: "90%",
  display: "flex",
  alignItems: "center",
  height: "64px",
  margin: "auto",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    paddingLeft: theme.spacing(2),
  },
}));

const AppBar = ({ logoURL }) => {
  return (
    <React.Fragment>
      <StyledAppBar elevation={0}>
        <Toolbar
          disableGutters
          style={{ height: "fit-content", width: "100%" }}
        >
          <Wrapper>
            <Logo
              src={logoURL !== "" ? logoURL : logo_placeholder}
              alt="Left logo"
            />
          </Wrapper>
        </Toolbar>
      </StyledAppBar>
    </React.Fragment>
  );
};

export default AppBar;
